import { Alert, Chip, Divider, IconButton, Stack, Typography } from "@mui/material"
import { useContext, useState, useEffect, useMemo } from "react"
import UserContext from "../../../services/Context/UserContext"
import API from "../../../services/API"
import { ArrowDownward, Check, Speed } from "@mui/icons-material"
import { txt } from "../../../services/translation"
import SponsorGauge from "./SponsorGauge"
import RewardClaim from "./RewardClaim"
import SponsorLink from "./SponsorLink"
import Affiliates from "./Affiliates"


export default function SponsorContent(){

    const {user} = useContext(UserContext);

    const [affiliates, setAffiliates] = useState(null);

    const [sponsor, setSponsor] = useState(null);

    const [counter, setCounter] = useState(null);

    useEffect(() => {

        API.get(`/users/${user.id}/affiliates`)
            .then(r => setAffiliates(r.data))

        API.get(`/users/${user.id}/sponsor`)
            .then(r => setSponsor(r.data || 'none'))

        API.get(`/sponsor/count`)
            .then(r => setCounter(r.data))

    }, [user])


    const credits = useMemo(() => {
        return (affiliates || [])
            .map(a => a.sponsor?.enrollments)
            .reduce((a,b) => a + b, 0)
    }, [affiliates])
    

    return (
    <Stack gap={2}>
        <Typography variant="h4">Offre de Parrainage LearnyLib 🚀</Typography>

        <Divider />

        <Typography>Partagez votre lien de parrainage avec vos confrères et confrères et commencez à cumuler des points pour des <b>récompenses exclusives</b> !</Typography>
                
        <SponsorLink />
                
        <Typography variant="h4">Comment ça marche ?</Typography>

        <Divider />
                
        <Alert severity="success" icon={<Speed />}><b>1 inscription payante via votre lien de parrainage = 1 point.</b></Alert>
                
        <Typography sx={{ pl: 3 }}>
            • 1 point = 20% de réduction sur la MasterClass de votre choix.
            <br/>
            • 2 points = 1 formation offerte parmi notre catalogue de formations cliniques.
            <br/>
            • 5 points = 1 MasterClass offerte.
        </Typography>

        <Alert severity="info"><b>Important :</b> Les points ne sont pas cumulables par filleul. Une seule inscription payante par filleul sera comptabilisée et vous donnera droit à 1 point.</Alert>
                
        <Stack direction="row" alignItems="center" gap={1}>
            <IconButton color="primary" href="#credits">
                <ArrowDownward />
            </IconButton> 
            <Typography>Suivez vos points en temps réel grâce à notre compteur de parrainage, et profitez de votre récompense dès que vous le souhaitez en cliquant sur "Réclamer ma récompense" !</Typography>
        </Stack>
                
        <Typography fontWeight="bold">Alors à vous de jouer !</Typography>
                
        <Typography>Invitez vos confrères et consœurs à se former avec LearnyLib et cumulez des avantages pour vous.</Typography>
                
        <Typography variant="h4" id="credits">Mes avantages</Typography>

        <Divider />
                
        {counter &&
            <Stack direction="row" justifyContent="center" alignItems="center" flexWrap="wrap" gap={1}>
                <SponsorGauge value={counter.count ?? 0} resetAt={counter.resetAt ?? user.createdAt} />
                <RewardClaim points={counter.count ?? 0} />
            </Stack>
        }

    
        {affiliates && <Stack gap={2}>
            <Stack direction='row' justifyContent='space-between' alignItems='center'>
                <Typography variant="h4">{txt('myReferrals')}</Typography>
    
                {credits > 0 &&
                    <Chip 
                        icon={<Check />}
                        label={`${credits} ` + txt('sponsoredPurchases')} 
                        color='info'
                    />
                }
            </Stack>

            <Divider />
    
            {affiliates.length > 0 ?
                <Affiliates items={affiliates} />
                :
                <Typography variant='body2' color="text.secondary">{txt('noReferralsYet')}</Typography>
            }
    
            {sponsor && <>
                <Typography variant="h4">{txt('mySponsor')}</Typography>

                <Divider />
    
                {sponsor === 'none' ? 
                    <Typography variant='body2' color="text.secondary">{txt('noSponsor')}</Typography>
                    :
                    <Typography variant='span'>{txt('sponsoredBy', { name: sponsor.name })}</Typography>
                }
            </>}
    
        </Stack>}
    </Stack>
    );
    
}